<div class="error-dialog-container">   
    <div class="error-dialog-left">
        <mat-icon>warning</mat-icon>
    </div>
    <div class="error-dialog-right">
        <mat-dialog-content> {{ data.message }}
            <!-- <br/>Please try again. -->
        </mat-dialog-content>
        <mat-dialog-actions class="close-button">
            <button mat-raised-button (click)="closeMe()" color="primary">Close</button>
        </mat-dialog-actions>
    </div>

    
</div>